import { render, staticRenderFns } from "./CategoryChoose.vue?vue&type=template&id=34f7a95e&scoped=true&"
import script from "./CategoryChoose.vue?vue&type=script&lang=js&"
export * from "./CategoryChoose.vue?vue&type=script&lang=js&"
import style0 from "./CategoryChoose.vue?vue&type=style&index=0&id=34f7a95e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f7a95e",
  null
  
)

export default component.exports